import { render, staticRenderFns } from "./NewCaseV2.vue?vue&type=template&id=25c7fbe3&scoped=true&"
import script from "./NewCaseV2.vue?vue&type=script&lang=js&"
export * from "./NewCaseV2.vue?vue&type=script&lang=js&"
import style0 from "./NewCaseV2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewCaseV2.vue?vue&type=style&index=1&id=25c7fbe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7fbe3",
  null
  
)

export default component.exports